// GLSL compartido entre terreno y rocas. Requiere el define CAUSTIC_ITER.
// Defines de calidad (solo desktop): SAND_RIPPLE (ondulaciones de arena), ROCK_BUMP (relieve de la piedra).
// LITE (móvil): luz con una sola capa de ruido.

export const COMMON_GLSL = /* glsl */`
  float _h3(vec3 p) { p = fract(p * 0.3183099 + 0.1); p *= 17.0; return fract(p.x * p.y * p.z * (p.x + p.y + p.z)); }
  // Value noise 3D en [0,1].
  float vnoise(vec3 x) {
    vec3 i = floor(x), f = fract(x);
    f = f * f * (3.0 - 2.0 * f);
    return mix(mix(mix(_h3(i), _h3(i + vec3(1, 0, 0)), f.x), mix(_h3(i + vec3(0, 1, 0)), _h3(i + vec3(1, 1, 0)), f.x), f.y),
               mix(mix(_h3(i + vec3(0, 0, 1)), _h3(i + vec3(1, 0, 1)), f.x), mix(_h3(i + vec3(0, 1, 1)), _h3(i + vec3(1, 1, 1)), f.x), f.y), f.z);
  }

  // LUZ DRAMÁTICA: la superficie filtra la luz en haces/manchas grandes que se mueven despacio → zonas muy
  // iluminadas y zonas en sombra, tanto en arena como en piedras. uLightContrast: 0 = luz uniforme, 1 = muy contrastada.
  uniform float uLightContrast, uLightScale;
  float lightPool(vec3 w) {
    float b = vnoise(vec3(w.x * uLightScale + uCausticTime * 0.06, 0.0, w.z * uLightScale * 1.3 - uCausticTime * 0.04));
    #ifndef LITE
    b = 0.62 * b + 0.38 * vnoise(vec3(w.x * uLightScale * 2.4, 3.0, w.z * uLightScale * 3.1 + uCausticTime * 0.08));
    #endif
    return mix(1.0, smoothstep(0.3, 0.72, b), uLightContrast);
  }

  // Niebla submarina: exponencial con la distancia a cámara → el fondo lejano se funde con el agua.
  uniform vec3 uFog, uFogBg;   // uFog = niebla tintada (cerca) · uFogBg = color de fondo exacto (lejos → sin borde visible)
  uniform float uFogDensity, uFogPower, uDim, uFarDark, uFarStart, uFarEnd;
  float fogAmount(float dist) { return 1.0 - exp(-pow(dist * uFogDensity, uFogPower)); }
  vec3 applyFog(vec3 col, float dist) {
    // Más allá de la roca del fondo todo se oscurece progresivamente (tanto el color como el tinte de la niebla).
    float far = smoothstep(uFarStart, uFarEnd, dist);
    vec3 fc = mix(uFog, uFogBg, smoothstep(uFarStart * 0.8, 8000.0, dist));
    fc = mix(fc, uFogBg, far * uFarDark);
    return mix(col * uDim * (1.0 - far * uFarDark), fc, fogAmount(dist));
  }

  // Caustics tileables (variante barata del clásico "water caustic"): líneas finas de luz que se retuercen.
  float caustic(vec2 uv, float time) {
    vec2 p = mod(uv * 6.28318530718, 6.28318530718) - 250.0;
    vec2 i = p;
    float c = 1.0;
    const float inten = 0.005;
    for (int n = 0; n < CAUSTIC_ITER; n++) {
      float t = time * (1.0 - (3.5 / float(n + 1)));
      i = p + vec2(cos(t - i.x) + sin(t + i.y), sin(t - i.y) + cos(t + i.x));
      c += 1.0 / length(vec2(p.x / (sin(i.x + t) / inten), p.y / (cos(i.y + t) / inten)));
    }
    c /= float(CAUSTIC_ITER);
    c = 1.17 - pow(c, 1.4);
    return pow(abs(c), 8.0);
  }
`;
